import React, { Component } from 'react';
import UserSelect from '../Users/UserSelect';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import IconButton from '@mui/material/IconButton';
import MainStore from '../../../MainStore';
import AuthStore from '../../Auth/AuthStore';
import ProjectColumn from './ProjectColumn';
import ProjectDialog from './ProjectDialog';
import { DragDropContext } from 'react-beautiful-dnd'
import './projects.css'

export default class ProjectKanban extends Component {
    constructor(props) {
        super(props);

        this.state = {
            projects: [],
            works: [],
            searchStr: '',
            filterProjectParticipantId: (localStorage.getItem('filterProjectParticipantId') !== 'null' && !!localStorage.getItem('filterProjectParticipantId')) ? localStorage.getItem('filterProjectParticipantId') : '',
            filterProjectParticipantName: (localStorage.getItem('filterProjectParticipantName') !== 'null' && !!localStorage.getItem('filterProjectParticipantName')) ? localStorage.getItem('filterProjectParticipantName') : '',
            isOnlyMyProjects: localStorage.getItem('filter_project_isOnlyMyProjects') === 'true',
            isOnlyProduct: localStorage.getItem('filter_project_isOnlyProduct') === 'true',
        };

        this.columns = [
            { name: 'Пауза', id: 'fc3e5bed-bbdc-429d-90b7-0e41c0443e54', isCollapseColumn: true },
            { name: 'Спящий', id: '0719053b-8b41-4c21-b279-9e179d177e4c', isCollapseColumn: true },
            { name: 'В работе', id: '8e13ffff-536c-48b6-8542-cc32f6300cb7', isCollapseColumn: true },
            { name: 'Проектирование', id: '49a878ff-2beb-4c37-a035-1a9787747415', isCollapseColumn: true },
            { name: 'Разработка', id: '70f1c06e-955f-4ed4-a7dc-62a5303bc0cf', isCollapseColumn: true },
            { name: 'Внедрение', id: '23c1548e-2ce7-4b9d-a9c3-299ebeedde1a', isCollapseColumn: true },
            { name: 'Ждем акты/оплату', id: 'a0f419f6-5f8c-491b-a118-c5c8494e8012', isCollapseColumn: true },
            { name: 'Закрыто', id: '0efb0050-469a-4104-ba06-547f7a8c2757', isCollapseColumn: true },
        ];

        this.handleOnDragEnd = this.handleOnDragEnd.bind(this);
        this.loadProjects = this.loadProjects.bind(this);
        this.handleProjectUpdate = this.handleProjectUpdate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCardOpen = this.handleCardOpen.bind(this);
        this.handleCreateProjectClick = this.handleCreateProjectClick.bind(this);
        this.handleQuickFilterMyProjectChange = this.handleQuickFilterMyProjectChange.bind(this);
        this.handleQuickFilterProductChange = this.handleQuickFilterProductChange.bind(this);
        this.handleQuickFilterParticipantChange = this.handleQuickFilterParticipantChange.bind(this);
    }

    componentDidMount() {
        this.loadProjects();
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    handleQuickFilterParticipantChange(user) {
        if (user) {
            localStorage.setItem('filterProjectParticipantId', user.id);
            localStorage.setItem('filterProjectParticipantName', user.name);
            this.setState({ filterProjectParticipantId: user.id, filterProjectParticipantName: user.name }, () => { this.loadProjects() });
        }
        else {
            localStorage.setItem('filterProjectParticipantId', '');
            localStorage.setItem('filterProjectParticipantName', '');
            this.setState({ filterProjectParticipantId: '', filterProjectParticipantName: '' }, () => { this.loadProjects() });
        }
    }

    loadProjects() {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");

        fetch('api/Project/GetKanbanProjects?name=' + this.state.searchStr + '&participantId=' + this.state.filterProjectParticipantId + '&myProjects=' + this.state.isOnlyMyProjects + '&onlyProduct=' + this.state.isOnlyProduct, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    scope.setState({ projects: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleCardOpen(project) {
        MainStore.setOpenedProject(project);
        MainStore.openProjectDialog(project, this.handleProjectUpdate);
    }

    sort(a, b) {
        var res = b.priorityOrder - a.priorityOrder;
        return res !== 0 ? res : a.position - b.position;
    }

    handleOnDragEnd(e) {
        const { destination, source } = e;
        if (!destination) {
            return
        }

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return
        }

        MainStore.setMaskVisible();
        const projects = this.state.projects.slice(0);
        var project = projects[projects.findIndex(s => s.id === e.draggableId)];
        var newStatusId = destination.droppableId;
        var columnWorks = projects.filter(w => w.statusId === newStatusId).sort(this.sort);
        var dragSrcPosition = 0;
        if (columnWorks.length !== 0) {
            dragSrcPosition = columnWorks[e.destination.index >= columnWorks.length ? columnWorks.length - 1 : e.destination.index].position;
        }

        var selectedProjects = projects.filter(w => w.isSelected).sort(this.sort);
        if (selectedProjects.length === 0) selectedProjects = [project];

        var scope = this;
        var token = localStorage.getItem("token");

        if (project.position < dragSrcPosition) dragSrcPosition = dragSrcPosition + 1;

        if (project.position !== dragSrcPosition) {
            projects.forEach(w => {
                if (w.position >= dragSrcPosition && w.id !== project.id) {
                    w.position = w.position + selectedProjects.length;
                }
            })
        }
        else {
            dragSrcPosition = dragSrcPosition - 1;
            projects.forEach(w => {
                if (w.position >= dragSrcPosition && w.id !== project.id) {
                    w.position = w.position + selectedProjects.length;
                }
            })
        }

        for (var i = 0; i < selectedProjects.length; i++) {
            selectedProjects[i].statusId = newStatusId;
            selectedProjects[i].position = dragSrcPosition + (selectedProjects.length - 1 - i);


            fetch('api/Project', {
                method: 'POST',
                body: JSON.stringify(selectedProjects[i]),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (res) {
                if (res.status === 401) {
                    AuthStore.openLogin();
                    MainStore.setMaskUnvisible();
                }
                else {
                    res.json().then((result) => {
                        var projects = scope.state.projects;

                        var index = projects.findIndex(w => w.id === result.id);
                        projects[index] = result;

                        MainStore.setMaskUnvisible();
                        scope.setState({ projects: projects });
                    }).catch((err) => console.log(err));
                }
            });
        }
    }

    handleCreateProjectClick() {
        MainStore.openProjectDialog({ name: this.state.searchStr });
        //this.setState({ isProjectDialogOpen: true, project: { name: this.state.projectName } });
    }

    handleProjectUpdate(result) {
        var projects = this.state.projects.slice(0);

        if (!MainStore.openedProject.id) {
            projects.push(result);
        }
        else {
            var index = projects.findIndex(w => w.id === result.id);

            projects[index] = result;
        }
        this.setState({ projects: projects });
    }

    handleQuickFilterMyProjectChange(evt) {
        var isOnlyMyProjects = evt.target.checked;
        localStorage.setItem('filter_project_isOnlyMyProjects', isOnlyMyProjects);
        this.setState({ isOnlyMyProjects: isOnlyMyProjects }, () => this.loadProjects());
    }

    handleQuickFilterProductChange(evt) {
        var isOnlyProduct = evt.target.checked;
        localStorage.setItem('filter_project_isOnlyProduct', isOnlyProduct);
        this.setState({ isOnlyProduct: isOnlyProduct }, () => this.loadProjects());
    }

    render() {
        return (
            <div>
                <div className="quick-filter-panel clearfix">
                    <div className="add-button-block">
                        <IconButton onClick={this.handleCreateProjectClick} size="large"><AddIcon style={{ fill: "red" }} /></IconButton>
                    </div>
                    <div className="quick-filter-item">
                        <div className="search-block clearfix">
                            <TextField required
                                id="standard-required"
                                label="Поиск"
                                fullWidth
                                margin="none"
                                value={this.state.searchStr}
                                autoComplete="off"
                                onKeyPress={(event) => (event.key === 'Enter') && this.loadProjects()}
                                onChange={this.handleChange('searchStr')}
                            />
                        </div>
                    </div>
                    <div className="quick-filter-item">
                        <div className="project-search-buttons">
                            <IconButton
                                onClick={() => this.setState({ searchStr: '' }, this.loadProjects)}
                                size="large"><CloseIcon /></IconButton>
                            <IconButton onClick={this.loadProjects} size="large"><SearchIcon /></IconButton>
                        </div>
                    </div>
                    <div className="quick-filter-item">
                        <UserSelect label="Участник" name={this.state.filterProjectParticipantName} handleSelect={this.handleQuickFilterParticipantChange} />
                    </div>
                    <div className="quick-filter-item">
                        <FormControlLabel
                            control={
                                <Checkbox checked={this.state.isOnlyMyProjects} onChange={this.handleQuickFilterMyProjectChange} value="true" />
                            }
                            label="Мои проекты"
                        />
                    </div>
                    <div className="quick-filter-item">
                        <FormControlLabel
                            control={
                                <Checkbox checked={this.state.isOnlyProduct} onChange={this.handleQuickFilterProductChange} value="true" />
                            }
                            label="Только продукты"
                        />
                    </div>
                    
                </div>
                <DragDropContext onDragEnd={this.handleOnDragEnd}>
                    {this.columns.map((column) => {
                        return (
                            <ProjectColumn
                                name={column.name}
                                id={column.id}
                                isCollapseColumn={column.isCollapseColumn}
                                onTimeChange={this.onTimeChange}
                                projects={this.state.projects.filter((w) => { return w.statusId === column.id; })}
                                onWorkUpdate={this.handleWorkFlagUpdate}
                                key={column.id}
                                onCardOpen={this.handleCardOpen}
                            />
                        );
                        })}
                </DragDropContext>
                
            </div>
        );
    }
}